import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LegalDistanceSales: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">LotusRecruiter</Link>
          <Link to="/login" className="text-sm text-lotus-gold font-semibold">
            {t('legal.customerLogin')}
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-md p-8 space-y-8">
          <div>
            <p className="text-sm uppercase tracking-widest text-gray-400 font-semibold">{t('legal.distance.label')}</p>
            <h1 className="text-3xl font-bold text-gray-900 mt-2">{t('legal.distance.title')}</h1>
            <p className="mt-4 text-gray-600 leading-relaxed">
              {t('legal.distance.intro')}
            </p>
          </div>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.distance.article1Title')}</h2>
            <p className="text-gray-600">
              {t('legal.distance.article1')}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.distance.article2Title')}</h2>
            <p className="text-gray-600">
              {t('legal.distance.article2')}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.distance.article3Title')}</h2>
            <p className="text-gray-600">
              {t('legal.distance.article3')}
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.distance.article4Title')}</h2>
            <p className="text-gray-600">
              {t('legal.distance.article4')}
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold text-gray-900">{t('legal.contact')}</h2>
            <p className="text-gray-600">info@aiotech.tr</p>
            <p className="text-gray-600">+90 533 614 67 74</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default LegalDistanceSales;
